// Mock data for OKRs and KPIs
export const mockYearlyOKRs = [
  {
    id: 1,
    area: 'Satisfacción Cliente',
    objective: 'Mantener una satisfacción del cliente superior al 90%',
    current: 87,
    target: 90,
    unit: '%'
  },
  {
    id: 2,
    area: 'Tiempo de Resolución',
    objective: 'Reducir el tiempo promedio de resolución a menos de 4 horas',
    current: 3.2,
    target: 4,
    unit: 'horas'
  },
  {
    id: 3,
    area: 'Primera Respuesta',
    objective: 'Mantener tiempo de primera respuesta bajo 30 minutos',
    current: 28,
    target: 30,
    unit: 'minutos'
  }
]

// Generate mock daily KPIs for the last 90 days
export const mockDailyKPIs = []

// Generate Resolution Time data
for (let i = 90; i >= 0; i--) {
  const date = new Date()
  date.setDate(date.getDate() - i)
  
  mockDailyKPIs.push({
    name: 'Resolution Time',
    timestamp: date,
    value: 2.5 + Math.random() * 2, // 2.5-4.5 hours
    unit: 'horas',
    target: 4
  })
}

// Generate First Response Time data
for (let i = 90; i >= 0; i--) {
  const date = new Date()
  date.setDate(date.getDate() - i)
  
  mockDailyKPIs.push({
    name: 'First Response Time',
    timestamp: date,
    value: 15 + Math.random() * 20, // 15-35 minutes
    unit: 'minutos',
    target: 30
  })
}

// Mock metrics summary
export const mockMetricsSummary = {
  totalTickets: 1250,
  resolvedTickets: 1100,
  avgResolutionTime: 3.2,
  avgFirstResponseTime: 28,
  customerSatisfaction: 87,
  slaCompliance: 92
}

// Utility functions
export function getKPIsForDateRange(startDate, endDate, metricName) {
  return mockDailyKPIs.filter(kpi => 
    kpi.name === metricName &&
    kpi.timestamp >= startDate &&
    kpi.timestamp <= endDate
  )
}

export function calculateMetricTrend(data) {
  if (data.length < 2) return 0
  
  const recent = data.slice(-7).reduce((sum, item) => sum + item.value, 0) / 7
  const previous = data.slice(-14, -7).reduce((sum, item) => sum + item.value, 0) / 7
  
  return ((recent - previous) / previous) * 100
}
